module.exports = __webpack_public_path__ + "static/media/doug.f1d9b2bf.jpg";